import { evaluatePredicate } from "../utils/predicateEvaluator";
import { useCallback } from "react";
import { useSelector, shallowEqual } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as programSelectors from "store/selectors/input/program/programSelectors";

const EMPTY_FLAGS = {};

export const useRetentionDefaults = () => {
  const { data: retentionsConfig } = staticDataService.useConfigQuery(
    "retentions"
  );
  const productLine = useSelector(programSelectors.selectResolvedProgram)
    ?.productLine;
  const flags = useSelector(
    (state) => state.input?.flags ?? EMPTY_FLAGS,
    shallowEqual
  );

  const getApplicableDefaults = useCallback(() => {
    if (!retentionsConfig?.defaults || !productLine) {
      return [];
    }

    const evaluationState = {
      program: { productLine },
      flags,
    };

    const applicableDefaults = retentionsConfig.defaults
      .filter((defaultConfig) => {
        if (!defaultConfig.predicate) return false;
        const matches = evaluatePredicate(
          defaultConfig.predicate,
          evaluationState
        );
        return matches;
      })
      .flatMap((defaultConfig) => defaultConfig.retentions || []);

    return applicableDefaults;
  }, [retentionsConfig, productLine, flags]);

  return {
    getApplicableDefaults,
    productLine,
    retentionsConfig,
  };
};
